<template>
	<side-window class="entity-window" :title="title" @pop="$emit('pop')" @close="$emit('close')">
		<div>
			<form-grid-layout>
				<div>
					<string-view ref="gaga" label="Search" @input="input" @enter="enter" :focus="true" />
				</div>
				<div v-if="results && results.length > 0">
					<div class="side-window__heading">Results</div>
					<div @click="select(item.id, item.search_label)" class="_result" v-for="item in results" v-bind:key="item.id">
						{{ item.search_label }}
					</div>
				</div>
				<div v-if="results && results.length == 0">
					<div class="side-window__heading">No results</div>
				</div>
			</form-grid-layout>
		</div>
	</side-window>
</template>

<script>
	export default {
		data: function () {
			return {
				search: '',
				results: null
			};
		},
		props: {
			name: String,
			title: String,
			endpoint: String,
			onSelect: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			input(name, value) {
				this.search = value;
			},
			select(id, label) {
				
				this.onSelect(id, label);
				this.$store.state.windowStack.pop();
			},
			enter() {
				
				

				var win = this;

				this.axios.get(this.endpoint + '?_search=' + this.search).then(function (r) {
					
					win.results = r.data;
				}, function () {
					
				});
			},
			mounted() {
				var win = this;

				this.Vue.$nextTick(function () {
					win.$refs.gaga.focus();
					
				});
			}
		}
	}
</script>

<style lang="scss">
	.entity-window {
		& ._result {
			cursor: pointer;
			font-size: 12px;
		}
	}
</style>
